import SetCallingIcon from './SetCallingIcon';
export default SetCallingIcon;